var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPoll = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 23.028c.202-.42.549-.542.997-.542 7.335.006 14.67.007 22.006 0 .448 0 .794.124.997.542V24H0v-.972zm16.99-2.047v-.373c0-4.355.003-6.71-.004-11.064-.001-.605.166-1.102.749-1.367.172-.078.38-.104.573-.105 1.127-.01 2.255-.006 3.383-.004.769 0 1.32.508 1.32 1.264.007 4.517.003 7.034.002 11.551 0 .023-.007.045-.016.098h-6.008zm-1.99.022H9V2.419c0-.87.507-1.38 1.381-1.382 1.082-.003 2.163-.003 3.245 0 .854.003 1.373.516 1.373 1.355v18.611zM.984 20.997v-7.546c.002-.904.491-1.414 1.387-1.422 1.093-.01 2.186-.01 3.279.001.836.009 1.347.488 1.354 1.305.015 1.842.004 5.684.002 7.525 0 .035-.01.069-.023.137H.984z",
  fill: "#00A146",
  fillRule: "evenodd"
})));

export default __webpack_public_path__ + "static/media/poll.3c6c3134.svg";
export { SvgPoll as ReactComponent };